import { i18n } from '@/i18n';

export const ValidationNumber = (precision, label = 'validation.number') => (value) => {
  if (value === null || value === '') {
    return true;
  }
  const stringValue = String(value);

  if (
    Number.isNaN(Number(stringValue))
    || stringValue.split('.')[1]
    && stringValue.split('.')[1].length > precision
  ) {
    return i18n.t(label);
  }
  return true;
};
